var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49693 13.4786H5.42432L12.9763 5.93822L12.5046 5.45939L12.0373 4.9993L4.49693 12.5512V13.4786ZM4.04984 14.6036C3.85657 14.6036 3.69528 14.5389 3.56595 14.4096C3.43662 14.2803 3.37195 14.119 3.37195 13.9257V12.6335C3.37195 12.4527 3.40705 12.2789 3.47725 12.1121C3.54744 11.9452 3.64407 11.8003 3.76714 11.6772L13.1061 2.34981C13.2147 2.24116 13.34 2.15896 13.4818 2.10319C13.6236 2.04742 13.7681 2.01953 13.9152 2.01953C14.0671 2.01953 14.2109 2.04742 14.3464 2.10319C14.482 2.15896 14.608 2.24501 14.7243 2.36136L15.6257 3.27432C15.7421 3.38298 15.8262 3.50509 15.8781 3.64066C15.9301 3.77623 15.956 3.91998 15.956 4.07191C15.956 4.21132 15.9301 4.35194 15.8781 4.49376C15.8262 4.63559 15.7421 4.76467 15.6257 4.88102L6.29835 14.2084C6.17528 14.3315 6.03033 14.4281 5.8635 14.4983C5.69667 14.5685 5.52287 14.6036 5.3421 14.6036H4.04984ZM12.9763 5.93822L12.5046 5.45939L12.0373 4.9993L12.9763 5.93822Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1fa09be05fae0dc1371589a2e1a77ab2.svg";
export { ForwardRef as ReactComponent };